import React, { useState, useEffect } from 'react';
import { List, Datagrid, FunctionField, SimpleList } from 'react-admin';
import { useMediaQuery, makeStyles, FormControl, InputLabel, Select, MenuItem, Paper } from '@material-ui/core';
import { customTheme } from "./customTheme";
import ParkingSearchSelector from "./components/ParkingSearchSelector";
import CustomSearch from './components/CustomSearch';
import { useLocation } from 'react-router-dom';
import CustomPagination from './components/CustomPagination';
import moment from 'moment';
// import CustomFilter from './components/CustomFilter';
import ImageGalleryDialog from './components/ImageGalleryDialog';
import ScrollableTable from './components/ScrollableTable';
import BrokenImageOutlinedIcon from '@material-ui/icons/BrokenImageOutlined';
import CustomDateTimePicker from "./components/CustomDateTimePickerV4";

const useStyles = makeStyles({
    list: {
        marginBottom: 0,
    },
    parkingSelectorContainer: {
        display: "grid",
        justifyContent: "space-between",
    },
});


export const MissedVisitors = props => {
    const classes = useStyles();
    const location = useLocation();

    const isSmallDevice = useMediaQuery(theme => customTheme.breakpoints.down("xs"));
    let defaultImg = "https://images.parksmart.in/main/Images/ParkingImages/default_parking.jpg"
    const [showFilter] = useState(sessionStorage.getItem("show_filter") === "1");
    let prevSearch = sessionStorage.getItem(location.pathname) ? JSON.parse(sessionStorage.getItem(location.pathname)) : ""
    const [currentParking, setCurrentParking] = useState(prevSearch.currentParking ? prevSearch.currentParking : {});
    const zoneIds = currentParking.zone_ids ? currentParking.zone_ids.split(",") : null;
    const zoneLabels = currentParking.zones ? currentParking.zones.split(";") : null;
    const finalZones = zoneIds && zoneLabels ? zoneIds.map((id, index) => (
        { id, name: zoneLabels[index] }
    )) : null;
    if (finalZones)
        finalZones.sort((a, b) => (a.name > b.name ? 1 : (a.name < b.name ? -1 : 0)));


    const [use24HourFormat] = useState(sessionStorage.getItem("use_24_hour_format") === "1");
    const [showTimeTillSeconds] = useState(sessionStorage.getItem("show_time_till_seconds") === "1");
    const [startDateTime, setStartDateTime] = useState(null);
    const [endDateTime, setEndDateTime] = useState(null);
    const [search, setSearch] = useState(prevSearch.inputSearch)
    let searchTypeState = ["Vehicle Number"]
    const [searchTypes, setSearchTypes] = useState(prevSearch.type ? prevSearch.type : "Vehicle Number");
    // const [filterListValue, setFilterListValue] = useState(prevSearch.radioValue ? prevSearch.radioValue : null)
    // const filterTypesInitState = [
    //     {
    //         resourcePath: "parkingDevices",
    //         filterType: "Entry Gate",
    //         filterParams: {
    //             access_key_id: currentParking.id,
    //             parking_info_id: currentParking.allZones ? currentParking.parking_info_id : null,
    //             sub_type: "CON-ENTRY"
    //         },
    //         dataList: [],
    //         searchList: [],
    //         listType: "Dynamic",
    //         resourceParam: "name",
    //         source: "name",
    //         showFilter: true,
    //         filterFormat: "Checkbox"
    //     },
    //     {
    //         resourcePath: "parkingDevices",
    //         filterType: "Exit Gate",
    //         filterParams: {
    //             access_key_id: currentParking.id,
    //             parking_info_id: currentParking.allZones ? currentParking.parking_info_id : null,
    //             sub_type: "CON-EXIT",
    //         },
    //         dataList: [],
    //         searchList: [],
    //         listType: "Dynamic",
    //         resourceParam: "name",
    //         source: "name",
    //         showFilter: true,
    //         filterFormat: "Checkbox"
    //     },
    // ];

    // const [settingFilterFormat, setSettingFilterFormat] = useState({})
    const filter = { start_time: startDateTime ? moment(startDateTime).format("YYYY-MM-DD HH:mm:ss") : "", end_time: endDateTime ? moment(endDateTime).format("YYYY-MM-DD HH:mm:ss") : "", search: { value: search ? search : "", type: searchTypes ? searchTypes : "" }, access_key: currentParking.id, parking_info_id: currentParking.allZones ? currentParking.parking_info_id : undefined };

    const renderTime = time => {
        const secondsFormat = showTimeTillSeconds ? ":ss" : "";
        if (use24HourFormat) return moment(time, "YYYY-MM-DD HH:mm:ss").format(`DD/MM/YYYY HH:mm${secondsFormat}`)
        return moment(time, "YYYY-MM-DD HH:mm:ss").format(`DD/MM/YYYY hh:mm${secondsFormat} A`)
    };

    const onParkingChange = (parking) => {
        setCurrentParking({ ...parking, allZones: true });
    };

    const onZoneChange = (event) => {
        setCurrentParking({
            ...currentParking,
            id: event.target.value,
            name: zoneLabels[zoneIds.findIndex(id => id === event.target.value)],
            allZones: event.target.value === "All"
        });
    };

    // useEffect(() => {
    //     let values = {}
    //     if (filterListValue) {
    //         for (let val in filterListValue) {
    //             if (filterListValue[val].filterType === "Entry Gate") values = { ...values, entry_user_ids: filterListValue[val].value ? JSON.stringify([].push(...filterListValue[val].value)) : undefined }
    //             else if (filterListValue[val].filterType === "Exit Gate") values = { ...values, exit_user_ids: filterListValue[val].value ? JSON.stringify([].push(...filterListValue[val].value)) : undefined }
    //         }
    //         setSettingFilterFormat(values)
    //     }
    //     if (filterListValue === null) setSettingFilterFormat({})

    // }, [filterListValue]); // eslint-disable-next-line react-hooks/exhaustive-deps

    return <div className={classes.list}>

        <div className={classes.parkingSelectorContainer} style={{ gridAutoFlow: isSmallDevice ? "row" : "column", gridTemplateColumns: isSmallDevice ? "100%" : "48% 48%", gridRowGap: isSmallDevice ? 18 : 0, margin: isSmallDevice ? "0 16px" : 0 }}>
            {showFilter && <ParkingSearchSelector
                value={currentParking}
                onChange={onParkingChange}
                clearable={true}
                pathName={location.pathname}
            />}

            {currentParking.zone_ids && currentParking.zone_ids.includes(',') &&
                <FormControl variant="outlined" style={{marginTop: 10}}>
                    <InputLabel>Zone Name</InputLabel>
                    <Select
                        value={currentParking.allZones ? "All" : currentParking.id}
                        onChange={onZoneChange}
                        label="Zone Name"
                        variant="outlined"
                    >
                        <MenuItem value="All">All</MenuItem>
                        {finalZones.map((zone, index) => (
                            <MenuItem key={index} value={zone.id}>{zone.name}</MenuItem>
                        ))}
                    </Select>
                </FormControl>
            }
        </div>

        <div className='customStyleForDataSearchDiv'>
            <CustomSearch search={search} setSearch={setSearch} searchTypes={searchTypes} setSearchTypes={setSearchTypes} searchTypeState={searchTypeState} pathName={location.pathname} />
            <CustomDateTimePicker startDateTime={startDateTime} setStartDateTime={setStartDateTime} endDateTime={endDateTime} setEndDateTime={setEndDateTime} hideCustomDate={true} hideMonthlyDate={true} />
            {/* <CustomFilter filterTypesInitState={filterTypesInitState} filterListValue={filterListValue} setFilterListValue={setFilterListValue} pathName={location.pathname} /> */}
        </div>
        {currentParking && currentParking.id ?
            <List
                {...props}
                style={{ marginTop: 20 }}
                title="Missed Visitors"
                bulkActionButtons={false}
                exporter={false}
                filter={filter}
                sort={{ field: 'timestamp', order: 'DESC' }}
                empty={false}
                pagination={<CustomPagination />}
                actions={false}
            >
                {
                    isSmallDevice ?
                        <SimpleList
                            primaryText={record => record && record.vehicle_number ? record.vehicle_number : "-"}
                            secondaryText={record => (<div>
                                {record.gate && <div><span style={{ color: "#5a5a5a" }}>Gate: </span>{record.gate}</div>}
                                {record.confidence && <div><span style={{ color: "#5a5a5a" }}>Confidence: </span>{record.confidence}</div>}
                                {record.timestamp && <div><span style={{ color: "#5a5a5a" }}>Entry Time: </span>{renderTime(record["timestamp"])}</div>}
                                {record.parking_name && <div><span style={{ color: "#5a5a5a" }}>Parking Name: </span>{record.parking_name}</div>}
                            </div>)}
                            onContextMenu={event => event.preventDefault()}
                            linkType={false}
                            rowStyle={() => ({ alignItems: "flex-start", borderBottom: "1px solid #18cc69" })}
                        />
                        :
                        <Datagrid component={ScrollableTable}>
                            <FunctionField
                                label="Image"
                                render={(record) => record.image_url ?
                                    <ImageGalleryDialog
                                        thumbnail={true}
                                        record={record}
                                        style={{ textAlign: "left" }}
                                        getImages={(record) => {
                                            let parkingImage = defaultImg;
                                            if (record.image_url) {
                                                return [record.image_url]
                                            } else {
                                                return [parkingImage]
                                            }
                                        }}
                                    />
                                    :
                                    <div style={{ display: "flex", justifyContent: "center", alignItems: "center", border: "1px solid #BDBDBD", minWidth: "50px", width: "60px", borderRadius: 5, height: "40px" }}>
                                        <BrokenImageOutlinedIcon />
                                    </div>
                                }
                            />
                            <FunctionField source="vehicle_number" label="Vehicle Number" render={record => record && record.vehicle_number ? record.vehicle_number : "-"} />
                            <FunctionField source="timestamp" label="Timestamp" render={record => renderTime(record["timestamp"])} />
                            {/* <FunctionField source="gate" label="Gate" render={record => record && record.gate ? record.gate : "-"} /> */}
                            <FunctionField source="confidence" label="Confidence" render={record => record && record.confidence ? record.confidence : "-"} />
                            <FunctionField source="description" label="Description" render={record => record && record.description ? record.description : "-"} />
                            <FunctionField source="parking_name" label="Parking Name" render={record => record && record.parking_name ? record.parking_name : "-"} />
                        </Datagrid>
                }
            </List>
            :
            <Paper style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', boxShadow: "0px 4px 15px #0000001a", padding: "14px 20px 18px 20px", marginTop: 10 }}>
                <div style={{ color: "#334D6E", fontSize: 13, fontFamily: "Poppins-Medium" }}>Please select a Parking.</div>
            </Paper>
        }
    </div>
};